import React from 'react';
import { connect } from "react-redux";
import {WIDTH} from './constants.js';
import {LEFT_SPACE} from './constants.js';

const PianoRollCursor = (props) => {
    if (props.cursor === undefined) {
        return (
            <div></div>
        );
    }

    let style = {
        left: Math.max(3, WIDTH * props.xScale * props.cursor),
        height: props.height
    };
    return (
        <div style={style} className="piano-roll-cursor flashit">
          <div className="cursor-top"/>
        </div>
    );
}

const mapStateToProps = (state, props) => {
    return {
        cursor: state.keyboard.cursor,
    };
};

export default connect(mapStateToProps, null)(PianoRollCursor);
